import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonToolbar, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { Icon, ConfirmDialog } from "components/common";
import { MoreActions } from "components/common/EntityDataTable";
import { useModalContext } from "common/contexts";
import useFeature from "hooks/useFeature";
import { useDeleteDetectionChain } from "security-app/hooks/useDetectionChainsAPI";
import EnableChainAction from "./EnableChainAction";
import { DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG } from "./constants";
const DetectionChainRowActions = ({ chain }) => {
  const { t } = useTranslation("enterprise_security_sigma");
  const managementEnabled = useFeature(DETECTION_CHAINS_MANAGEMENT_FEATURE_FLAG);
  const { setModal, setEntity } = useModalContext();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const { mutate: deleteChain } = useDeleteDetectionChain();
  const immutable = chain.scope === "ILLUMINATE";
  const onEdit = () => {
    setEntity(chain);
    setModal("EDIT-CHAIN");
  };
  const onConfirmDelete = () => {
    deleteChain({ id: chain.id, name: chain.name });
    setShowDeleteConfirm(false);
  };
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(EnableChainAction, { chain }), managementEnabled && /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(MenuItem, { disabled: immutable, onClick: onEdit }, /* @__PURE__ */ React.createElement(Icon, { name: "edit_square", size: "xs" }), " ", t("common:actions.edit")), /* @__PURE__ */ React.createElement(DeleteMenuItem, { disabled: immutable, onClick: () => setShowDeleteConfirm(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete", size: "xs" }), " ", t("common:actions.delete"))), showDeleteConfirm && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: t("detection_chain_row_actions.delete_title"),
      show: true,
      onConfirm: onConfirmDelete,
      onCancel: () => setShowDeleteConfirm(false)
    },
    t("detection_chain_row_actions.delete_message", { name: chain.name })
  ));
};
export default DetectionChainRowActions;
